import { __read, __spread } from "tslib";
export var createLegendLabels = function (data, labelSelector) {
    var labels = data.map(function (item) { return item[labelSelector]; });
    var uniqLabels = new Set(labels);
    return __spread(uniqLabels);
};
